import React, { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';
import { TrendingUp, TrendingDown, Link, BarChart3, Target, Zap } from 'lucide-react';
// Animated number component
function AnimatedNumber({
  value
}: {
  value: number;
}) {
  const spring = useSpring(0, {
    mass: 0.8,
    stiffness: 75,
    damping: 15
  });
  const display = useTransform(spring, current => Math.round(current).toLocaleString());
  useEffect(() => {
    spring.set(value);
  }, [value, spring]);
  return <motion.span data-id="element-89">{display}</motion.span>;
}
const metrics = [{
  label: 'Total Backlinks',
  value: 12483,
  change: '+12.5%',
  trend: 'up',
  icon: Link,
  color: 'text-blue-400'
}, {
  label: 'Domain Authority',
  value: 42,
  change: '+2.1%',
  trend: 'up',
  icon: Zap,
  color: 'text-amber-400'
}, {
  label: 'Keywords Tracked',
  value: 892,
  change: '-0.4%',
  trend: 'down',
  icon: Target,
  color: 'text-purple-400'
}, {
  label: 'Monthly Traffic',
  value: 45200,
  change: '+8.2%',
  trend: 'up',
  icon: BarChart3,
  color: 'text-emerald-400'
}];
export function MetricCards() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-90">
      {metrics.map((metric, index) => <motion.div key={metric.label} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.1 + 0.5
    }} className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300 group" data-id="element-91">
          <div className="flex justify-between items-start mb-4" data-id="element-92">
            <div className={`p-2 rounded-lg bg-white/5 ${metric.color} group-hover:scale-110 transition-transform duration-300`} data-id="element-93">
              <metric.icon className="w-5 h-5" data-id="element-94" />
            </div>
            <div className={`flex items-center text-xs font-medium px-2 py-1 rounded-full ${metric.trend === 'up' ? 'bg-green-500/10 text-green-400' : 'bg-red-500/10 text-red-400'}`} data-id="element-95">
              {metric.trend === 'up' ? <TrendingUp className="w-3 h-3 mr-1" data-id="element-96" /> : <TrendingDown className="w-3 h-3 mr-1" data-id="element-97" />}
              {metric.change}
            </div>
          </div>

          <div className="space-y-1" data-id="element-98">
            <h3 className="text-3xl font-bold text-white tracking-tight" data-id="element-99">
              <AnimatedNumber value={metric.value} data-id="element-100" />
            </h3>
            <p className="text-sm text-white/40 font-medium" data-id="element-101">{metric.label}</p>
          </div>
        </motion.div>)}
    </div>;
}